import { atom } from 'recoil'
import { StateKeys } from '../../../../constants/stateKeys'
import { StorageKey } from '../../../../constants/StorageKey'
import { storageEffect } from '../../../../effects/storageEffect'
import { PlacePredictionCompat } from '../../../../hooks'

export const recentlySelectedLocations = atom<PlacePredictionCompat[]>({
  key: StateKeys.recentlySelectedLocations,
  default: [],
  effects: [storageEffect(StorageKey.RecentlySelectedLocations)]
})
